export default __webpack_public_path__ + "static/media/devices_1.a24623db.png";